/**
 * Prompt Repository
 *
 * Handles storage operations for saved system prompts.
 */

import { storage } from "./storageService";

export class PromptRepository {
  async getSavedPrompt(userEmail: string): Promise<string | null> {
    return await storage.get(userEmail);
  }

  async saveSavedPrompt(prompt: string, userEmail: string): Promise<void> {
    if (!prompt.trim()) {
      storage.clear(userEmail);
    } else {
      await storage.set(prompt, userEmail);
    }
  }

  async clearSavedPrompt(userEmail: string): Promise<void> {
    storage.clear(userEmail);
  }
}

export const promptRepository = new PromptRepository();
